import type {
  CSSProperties,
  ElementType,
  HTMLAttributes,
  ReactNode,
} from "react";
import "./LayoutPrimitives.scss";

type ContainerProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children?: ReactNode;
  fluid?: boolean;
  maxWidth?: CSSProperties["maxWidth"];
};

export function Container({
  as: Component = "div",
  children,
  className = "",
  fluid = false,
  maxWidth,
  style,
  ...props
}: ContainerProps) {
  return (
    <Component
      className={`layout-container ${fluid ? "layout-container--fluid" : ""} ${className}`.trim()}
      style={{
        ...style,
        ...(maxWidth === undefined ? {} : { maxWidth }),
      }}
      {...props}
    >
      {children}
    </Component>
  );
}
